import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {capGQV} from '/util/attribute.util';

import {styles} from './GroupQualifyingVolume.style';

interface GroupQualifyingVolumeItem {
  gqv: string;
}

interface GroupQualifyingVolumeProps {
  tt: (key: string, defaultValue: string) => string;
  item: GroupQualifyingVolumeItem | null;
}

export const GroupQualifyingVolume: React.FC<GroupQualifyingVolumeProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}: GroupQualifyingVolumeProps) => {
  const gqv = get(item, 'gqv', '');

  return (
    <View style={styles.attributes}>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        variant="button"
        emphasis="medium">
        {tt('gqv', 'GQV')}{' '}
      </Text>
      <FormattedNumber
        // @ts-expect-error TS(2322): Type '{ testID: any; truncate: true; value: any; t... Remove this comment to see the full error message
        testID={Reports.reportCoachGQV}
        truncate
        value={capGQV(gqv)}
        textEmphasis="medium"
        boldText={false}
      />
    </View>
  );
};

export default withTranslation('report.record.gqv')(GroupQualifyingVolume);
